// 家戶成員：誰在哪個家戶、什麼角色（家戶角色只給本組織的成員，SPEC #org-model-roles）。家人加入 = 邀請進我的個人組織（成員分頁）；
// 只經分享進來的家戶看不到成員，不列。
import { useTranslation } from 'react-i18next';
import { useHomeDetails, homeLabel } from '../devices/useHomeDetails';

export function HomeMembersTab() {
  const { t } = useTranslation();
  const results = useHomeDetails().filter((r) => !(r.home as { external?: boolean }).external);
  return (
    <section className="card">
      <h2 className="section-title">{t('people.home_members')}</h2>
      <p className="muted small">{t('people.home_members_hint')}</p>
      {results.length === 0 && <p className="muted">{t('overview.no_homes')}</p>}
      {results.map((r) => (
        <div key={r.home.home_id} className="home-members">
          <h3 className="small">
            {homeLabel(r.home)} <span className="chip">{t(`people.hrole_${r.home.role}`, { defaultValue: String(r.home.role ?? '') })}</span>
          </h3>
          {r.loading && <p className="muted small">{t('common.loading')}</p>}
          {r.detail && r.detail.members.length === 0 && <p className="muted small">{t('people.members_hidden')}</p>}
          <ul className="plain-list">
            {(r.detail?.members ?? []).map((m) => {
              const mm = m as { user_id: string; role: string; display_name?: string; email?: string };
              return (
                <li key={mm.user_id} className="row">
                  <span>{mm.display_name || mm.email || t('iam.left_member')}</span>
                  <span className="chip">{t(`people.hrole_${mm.role}`, { defaultValue: mm.role })}</span>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </section>
  );
}
